import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-specialist-ooo-alert',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="ooo" class="alert alert-info mx-3 mt-3 mb-0 d-flex align-items-center" role="alert">
      <i class="fa fa-exclamation-triangle me-2"></i>
      <div>
        Dr. <strong>{{ ooo.specialistName }}</strong> is out of office until <strong>{{ ooo.returnDateText }}</strong> so responses may be delayed. If your message is urgent, another specialist and/or Mission admin may be able to respond sooner.
      </div>
    </div>
  `
})
export class SpecialistOooAlertComponent {
  @Input() ooo: { specialistName: string; returnDateText: string } | null = null;
}
